const useVehiclesToShow = ({
  staticVehicles,
  staticCount,
  queryString,
  vehicles = [],
  count,
  loading,
}) => {
  // we recieved no static vehicles, only work with apollo vehicles:
  if (staticVehicles.length === 0) {
    return {
      showLoading: loading,
      totalNumberOfVehicles: count,
      vehiclesToShow: vehicles,
    };
  }

  // we will only show the staticVehicles gotten from gatsby when:
  // we are not searching (so queryString is set)
  // there are more apollo vehicles than staticVehicles; because of fetchMore
  const liveFetching = (queryString || vehicles.length > staticVehicles.length);
  const vehiclesToShow = liveFetching ? vehicles : staticVehicles;

  // and when Apollo is loading and we aren't using staticVehicles, show the loading
  return {
    showLoading: loading && queryString && vehiclesToShow.length === 0,
    totalNumberOfVehicles: liveFetching ? count : staticCount,
    vehiclesToShow,
  };
};

export default useVehiclesToShow;
